



































































import { api } from '@/plugins/api';
import { connect } from '@/plugins/websocket';
import { Mutations } from '@/store/mutations';
import { getCreateAccidentBy5G } from '@/api';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import videoCall from '@/phoneVideo/video-call';
import myDialog from '@/components/custom/myDialog.vue'
const command = {
  INVITE_REQUEST: 'INVITE_REQUEST'
};

@Component({
  name: 'AppMain',
  components: {myDialog}
})
export default class AppMain extends Vue {
  public answerDialogVisible = false;
  public currentAddress = '';
  public currentPhoneNumber = '';
  public inviteRequest5G = false;
  public invite5GId = '';
  public inviteRequestVisible = false;
  get cachedViews() {
    return this.$store.state.tagsView.cachedViews;
  }

  get displayPhoneNumber() {
    if (this.currentPhoneNumber && this.currentPhoneNumber.length === 11) {
      return this.currentPhoneNumber.replace(
        /(\d{3})(\d{4})(\d{4})/,
        '$1-$2-$3'
      );
    }
    return this.currentPhoneNumber;
  }

  get key() {
    return this.$route.path;
  }

  get user() {
    return this.$store.state.user;
  }
  get currentRole() {
    return this.$store.getters.accidentRoleName;
  }
  get videoType() {
    return this.$store.state.app.videoType;
  }
  get videoPhone() {
    return this.$store.state.app.videoPhone;
  }
  public answer() {
    this.answerDialogVisible = false;
    // @ts-ignore
    this.$refs.player.pause();
    if (this.videoType) { // 5g视频
    console.log('5g视频');

      const extension = this.user.sysUser && this.user.sysUser.extension;
      const phoneNumber = this.videoPhone;
      if (this.inviteRequest5G) {
        localStorage.setItem('isReady','0');
        this.$store.commit('app/SET_ISHANGUP', false);
        console.log( this.invite5GId);

        this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改就绪样式
        this.$router.push({
          name: 'AccidentAdd',
          params: {
            id: this.invite5GId
          }
        });
        this.inviteRequest5G = false;
        this.$store.commit('app/INVITEREQUEST5G', {inviteRequest5G:false});
      }else {
        getCreateAccidentBy5G(phoneNumber,extension).then(res =>{
          console.log(res);
          localStorage.setItem('isReady','0');
          this.$store.commit('app/SET_ISHANGUP', false);
          this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改就绪样式
          this.$router.push({
            name: 'AccidentAdd',
            params: {
              id: res.data
            }
          });
        });
      }

    }else { // 小程序视频
      api.video.trtc.accept.r().then(accidentId => {
        setTimeout(() => {
          this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改就绪样式
          localStorage.setItem('isReady','0');
          const { extension } = this.user.sysUser;
          if (extension) {
            videoCall.logout(msg => {
              console.log("分机登出：" + msg);
            });
          }
          // this.$router.push({
          //   // name: 'AccidentAdd',
          //   name: 'home',
          //   params: {
          //     id: accidentId || this.remoteInfo.accidentId
          //   }
          // });
          console.info("this.remoteInfo", this.remoteInfo)
          this.$router.push({
            name: 'mediatorInfo',
            params: {
              id: accidentId || this.remoteInfo.accidentId
            }
          });
        }, 1500);
      });
    }

  }

  public remoteInfo = {
    address: '',
    callPhone: '',
    command: '',
    inviterId: '',
    inviterName: '',
    longitude: 0.0,
    latitude: 0.0,
    reportPhone: '',
    accidentId: ''
  };

  public alertMessage(type) {
    if (type === 1) {
      this.answerDialogVisible = true;
    }
    console.log(88888);

    // 浏览器视频弹窗
    if (window.Notification) {
      let popNotice = () => {
        if (Notification.permission == 'granted') {
          let notification = new Notification('Hi!', {
              body: type === 1 ? '您有一个视频通话请求！' : '您有一条新的事故要处理！',
          });
          notification.onclick = function() {
              notification.close();
          };
        }
      };
      if (Notification.permission == 'granted') {
          popNotice();
      } else if (Notification.permission !== 'denied') {
          Notification.requestPermission(function (permission) {
            popNotice();
          });
      }
    }else {
      console.log('浏览器不支持弹屏提示');
    }
  }

  public handleInviteRequest(data) {
    this.remoteInfo = data;
    this.currentAddress = data.address;
    this.currentPhoneNumber = data.callPhone;

    this.answerDialogVisible = true;
    // @ts-ignore
    this.$refs.player.play();
    this.alertMessage(1);
    this.$store.commit('app/SET_VIDEODATA', {type:0});
    // this.inviteRequestVisible = true;
  }

  public created() {
    // 先 创建 stomp 实例 并 connect 主动创建
    connect(true);
    // 然后 主动订阅

    this.$subscribe(
      `/user/${(this.$store.state as any).user.username}/topic`,
      ({ data }: any) => {
        // 等待连接
        if (data.command === 'CONNECT_REQUEST') {
          console.log('手机号', data.phone, '等待连接', data);
          if (localStorage.getItem('isReady') === '1' && (this.currentRole === '坐席' || this.currentRole ==='管理员')) {
            this.currentPhoneNumber = data.phone;
            this.currentAddress = data.address;
            this.answerDialogVisible = true;
            this.$store.commit('app/SET_VIDEODATA', {type:0});
            // @ts-ignore
            this.$refs.player.play();
            this.alertMessage(1);
          }
        } else if (data.command === 'STATUS_CHANGED') {
          if (data.status === 'READY') {
            console.log('READY');
            localStorage.setItem('isReady','1');
            this.$store.commit(Mutations.CHANGE_READY_STATE);
          } else if (data.status === 'LEAVE') {
            console.log('LEAVE');
            // localStorage.setItem('isReady','0');
            this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改离岗样式
          } else if (data.status === 'OFFLINE') {
            console.log('账号另外登录');
            this.$confirm('此账号已在其他设备登录, 您可以返回首页重新登录！', '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$store.dispatch('LogOut').then(() => {
                location.href = '/';
              });
            }).catch(() => {
              this.$store.dispatch('LogOut').then(() => {
                location.href = '/';
              });
            });
            setTimeout(() => {
              this.$store.dispatch('LogOut').then(() => {
                location.href = '/';
              });
            }, 3000);
          }
        } else if (data.command === 'INVITE_REQUEST') {
          if (localStorage.getItem('isReady') === '1') {
            console.log('邀请进入视频');
            this.handleInviteRequest(data);
          }
        } else if (data.command === 'HIDE_POPOVER') {
          this.answerDialogVisible = false;
          // @ts-ignore
          this.$refs.player.pause();
        } else if(data.command === 'NOTIFY_MESSAGE') {
          console.log('医院拖修车通知');
          this.alertMessage(2);
          this.$confirm('您有一条新的事故待处理！', '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({
                name: 'AccidentEdit',
                params: { id: data.accidentId, detailId: data.id }
              })
            }).catch(() => {
              console.log('取消');
            });
        } else if(data.command === 'INVITE_REQUEST_5G') {
          if (localStorage.getItem('isReady') === '1' && (this.currentRole === '交警' || this.currentRole === '保险员')) {
            console.log('5g视频邀请');
            this.inviteRequest5G = true;
            this.invite5GId = data.accidentId;
            this.$store.commit('app/SET_VIDEODATA', {type:1});
            this.$store.commit('app/INVITEREQUEST5G', {inviteRequest5G:true, invite5GId:data.accidentId});
            // this.alertMessage(1);
          }
        } else {
          console.log('其他状态', data);
          const message = {
            REQUEST_UNRESOLVED: '被邀请人超时未接受邀请',
            INVITE_REFUSED: '被邀请人拒绝邀请',
            PARTY_LEAVED: '报警人已退出房间'
          }[data.command];
          if (message) {
            this.$message.warning(message);
          }
        }
      }
    );
  }

  public refuse() {
    console.log('拒绝');
    // @ts-ignore
    this.$refs.player.pause();
    this.answerDialogVisible = false;
    if (this.videoType) {
      videoCall.hangupPhone(
        () => console.log('挂断了'),
        () => console.log('挂断失败')
      );
      this.$store.commit('app/SET_VIDEODATA', {type:0});
    }else {
      api.video.trtc.refuse.r();
    }
    api.video.trtc.leave.r().then((res:any) => {
      if (res && res.code === '200') {
        this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改离岗样式
      }
    });
    localStorage.setItem('isReady','0');
  }
  @Watch('videoType')
  videoTypeChange(val: Number) {
    let isReady = localStorage.getItem('isReady');
    if (val && isReady==='1') {
      if ((this.currentRole === '交警' || this.currentRole === '保险员') && this.inviteRequest5G) {
        setTimeout(() => {
          this.answerDialogVisible = true;
          // @ts-ignore
          // this.$refs.player.play();
          this.alertMessage(1);
          setTimeout(() => {
            if (this.answerDialogVisible) {
              this.refuse();
            }
          }, 10000);
        }, 3000);
      }else {
        this.answerDialogVisible = true;
        console.log('5g弹窗');

        this.alertMessage(1);
        setTimeout(() => {
          if (this.answerDialogVisible) {
            this.refuse();
          }
        }, 10000);
      }
    }
  }
}
